"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FilterNav;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _icon = require("@site/pattern-library-utils/icon");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _motionFunctions = require("@site/pattern-library-core/motion-functions");
var _siteSearchContext = require("./site-search-context");
var _text = _interopRequireDefault(require("@ux/text"));
var _core = require("@linaria/core");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/** @module FilterNav */

const Container = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Container",
  class: "pl-cx087ct"
});
const GroupList = /*#__PURE__*/(0, _react2.styled)("ul")({
  name: "GroupList",
  class: "pl-g16ze873"
});
const commonButtonStyles = `
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  height: 3.125rem;
  cursor: pointer;
  border-radius: ${_intents.default.ux.action.borderRadius};
  transition: ${(0, _motionFunctions.getCSSTransition)('swift', '200', ['background', 'color', 'border', 'transform'])};
  background: ${_intents.default.ux.actionControl.backgroundColor};
  border: ${_intents.default.ux.actionControl.borderWidth} solid ${_intents.default.ux.actionControl.borderColor};
  text-decoration: none;
  padding: 0 ${_patternLibraryUtils.density['8']};
  color: ${_intents.default.ux.actionControl.foregroundColor};

  &:hover {
    transform: scale(1.02);
    border: ${_intents.default.ux.actionControl.borderWidth} solid ${_intents.default.ux.actionControlHovered.borderColor};
    text-decoration: none;
  }

  &.active {
    background: ${_intents.default.ux.actionControlChosen.backgroundColor};
    border: ${_intents.default.ux.actionControl.borderWidth} solid ${_intents.default.ux.actionControlChosen.borderColor};
    color: ${_intents.default.ux.actionControlChosen.foregroundColor};

    &:hover {
      color: ${_intents.default.ux.actionControlChosen.foregroundColor};
    }
  }
`;
const filterButton = "pl-fukm1ou";
const filterLinkButton = "pl-f1t7bi80";
const List = /*#__PURE__*/(0, _react2.styled)("li")({
  name: "List",
  class: "pl-l1lup9g9"
});
const ContentItem = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ContentItem",
  class: "pl-c15w46ey"
});
const LinkArrowComponent = /*#__PURE__*/(0, _react2.styled)(_icon.Icon)({
  name: "LinkArrowComponent",
  class: "pl-lohklct"
});

/**
 * FilterNavItem Component.
 *
 * @param {Object} props React props
 * @param {String} props.filterKey Key for each item
 * @param {String} props.filterText Button Text
 * @param {String} props.ariaLabel Aria Label for each item
 * @param {String} props.link Href for each link item
 * @param {Boolean} props.isActive Active State
 * @param {Function} props.onClick Forwarded Func
 * @param {String} props.searchValue Forwarded Value
 * @returns {React.ReactElement} FilterNavItem Component
 * @public
 */

function FilterNavItem({
  filterKey,
  filterText,
  ariaLabel,
  link,
  isActive,
  onClick,
  searchValue
}) {
  const {
    domainSearchUrl,
    trackingCustomProperties
  } = (0, _react.useContext)(_siteSearchContext.SiteSearchContext);
  const buttonProps = {
    'id': `id-${filterKey}`,
    'value': searchValue,
    'onClick': onClick,
    'aria-label': ariaLabel,
    'as': 'title',
    ..._patternLibraryUtils.tracking.create((0, _patternLibraryUtils.applySnakeCase)(`sitesearch_tab_${filterText}`), true, false, trackingCustomProperties)
  };
  return /*#__PURE__*/_react.default.createElement(List, {
    "data-cy": "filter-nav-item"
  }, link ? /*#__PURE__*/_react.default.createElement(_text.default.a, (0, _extends2.default)({
    href: domainSearchUrl
  }, buttonProps, {
    className: `${filterLinkButton} ${isActive && 'active'}`
  }), /*#__PURE__*/_react.default.createElement(ContentItem, null, filterText, /*#__PURE__*/_react.default.createElement(LinkArrowComponent, {
    name: "link-arrow",
    fill: _intents.default.ux.box.foregroundColor
  }))) : /*#__PURE__*/_react.default.createElement(_text.default.button, (0, _extends2.default)({}, buttonProps, {
    className: `${filterButton} ${isActive && 'active'}`
  }), /*#__PURE__*/_react.default.createElement(ContentItem, null, filterText, link && /*#__PURE__*/_react.default.createElement(LinkArrowComponent, {
    fill: _intents.default.ux.box.foregroundColor
  }))));
}
FilterNavItem.propTypes = {
  filterKey: _propTypes.default.string,
  filterText: _propTypes.default.string,
  ariaLabel: _propTypes.default.string,
  link: _propTypes.default.string,
  isActive: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  searchValue: _propTypes.default.string
};

/**
 * FilterNav Component.
 *
 * @param {Object} props React props
 * @param {String} props.allText All Text
 * @param {Array} props.filterNavLinks Filter Items
 * @param {String} props.partial Theme partial
 * @returns {React.ReactElement} FilterNav Component
 * @public
 */

function FilterNav({
  allText = 'All',
  filterNavLinks,
  partial = 'actionControlAlt'
}) {
  const {
    activeFilter,
    setActiveFilter,
    trackingCustomProperties,
    setTrackingCustomProperties
  } = (0, _react.useContext)(_siteSearchContext.SiteSearchContext);
  const [toggleState, setToggleState] = (0, _react.useState)(0);
  const [isResetActived, setIsResetActived] = (0, _react.useState)(true);
  const handleClick = (index, filterKey, link) => {
    // if link is present, do not set toggle state and allow browser to redirect
    if (!link) {
      (0, _patternLibraryUtils.scrollToTop)();
      setToggleState(index);
      setIsResetActived(!(index >= 0));
      const selectedFilter = filterKey.toLowerCase();
      setActiveFilter(selectedFilter);
      setTrackingCustomProperties({
        ...trackingCustomProperties,
        tab: selectedFilter
      });
    }
  };
  (0, _react.useEffect)(() => {
    handleClick(filterNavLinks.findIndex(section => section.filterKey.toLowerCase() === activeFilter), activeFilter);
  }, [activeFilter]);
  if (!filterNavLinks?.length) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement(Container, {
    "data-cy": "filter-nav",
    "data-partial": partial
  }, /*#__PURE__*/_react.default.createElement(GroupList, null, /*#__PURE__*/_react.default.createElement(FilterNavItem, {
    filterText: allText,
    onClick: () => {
      setIsResetActived(true);
      setActiveFilter(allText.toLowerCase());
    },
    isActive: isResetActived
  }), filterNavLinks.map(({
    filterKey,
    filterText,
    link,
    ...rest
  }, idx) => {
    return /*#__PURE__*/_react.default.createElement(FilterNavItem, (0, _extends2.default)({
      filterKey: filterKey,
      isActive: !isResetActived && toggleState === idx,
      onClick: () => handleClick(idx, filterKey, link),
      filterText: filterText,
      key: idx,
      link: link
    }, rest));
  })));
}
FilterNav.propTypes = {
  allText: _propTypes.default.string.isRequired,
  selectedFilter: _propTypes.default.string,
  filterNavLinks: _propTypes.default.arrayOf(_propTypes.default.shape(FilterNavItem.propTypes)).isRequiredFilterNav,
  partial: _propTypes.default.string
};